module.exports = __webpack_public_path__ + "img/coming-soon.6948f00.png";